import { render, staticRenderFns } from "./TransactionHistoryError.vue?vue&type=template&id=1cb454dc&scoped=true&"
import script from "./TransactionHistoryError.vue?vue&type=script&lang=js&"
export * from "./TransactionHistoryError.vue?vue&type=script&lang=js&"
import style0 from "./TransactionHistoryError.vue?vue&type=style&index=0&id=1cb454dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb454dc",
  null
  
)

export default component.exports